import type { QueryClient } from '@tanstack/react-query'
import { createRootRouteWithContext, Link, Outlet, type ErrorComponentProps } from '@tanstack/react-router'

import { AuthGate } from '@/features/auth/auth-gate'
import { AppShell } from '@/features/shell/app-shell'
import { ErrorNotice, Page } from '@/components/kit/page'
import { Button } from '@/components/ui/button'
import { Empty, EmptyDescription, EmptyHeader, EmptyTitle } from '@/components/ui/empty'

export interface RouterContext {
  queryClient: QueryClient
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
  notFoundComponent: NotFound,
  errorComponent: RouteError,
})

function RootComponent() {
  return (
    <AuthGate>
      {(session) => (
        <AppShell me={session.me} config={session.config}>
          <Outlet />
        </AppShell>
      )}
    </AuthGate>
  )
}

function NotFound() {
  return (
    <Page>
      <Empty className="border">
        <EmptyHeader>
          <EmptyTitle>Nothing here</EmptyTitle>
          <EmptyDescription>This page does not exist.</EmptyDescription>
        </EmptyHeader>
        <Button asChild variant="outline" size="sm">
          <Link to="/">Back to the overview</Link>
        </Button>
      </Empty>
    </Page>
  )
}

function RouteError({ error }: ErrorComponentProps) {
  return (
    <Page>
      <ErrorNotice error={error} />
    </Page>
  )
}
